<template>
  <b-collapse
    :model-value="open"
    :animation="animation"
    @open="onOpen"
    @close="onClose"
    ref="collapse"
  >
    <template #trigger="{ open: slotIsOpen }">
      <slot name="trigger" :open="slotIsOpen" />
    </template>
    <slot />
  </b-collapse>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CollapseView',
  emits: ['open', 'close'],
  slotsDefinition: {
    trigger: { open: Boolean }
  },
  props: {
    open: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      default: 'fade'
    },
    ariaId: {
      type: String
    }
  },
  computed: {
    isOpen() {
      return this.$refs.collapse.isOpen;
    }
  },
  methods: {
    onOpen(...args) {
      this.$emit('open', ...args);
    },
    onClose(...args) {
      this.$emit('close', ...args);
    },
    toggle() {
      this.$refs.collapse.toggle();
    }
  }
};
</script>
